import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { ButtonComponent } from "../../../../ui/molecules/button/newButton"
import { ProtocolSearch } from "../../../../ui/molecules/ProtocolSearch"
import { MadfarmStaticSelect } from "../../../../ui/molecules/select/newSelect/static"
import TextArea from "../../../../ui/molecules/textArea"
import { optionsFormatter, ReportingStateStatusOption } from "../../../../utils"
import { GetAllReportingStates, ReportingStateCreation, ReportingStateDelete, ReportingStateValidation, resetGetAllReportingStateResponse, resetReportingStateCreationRequest, resetReportingStateCreationStatus, resetReportingStateDeleteStatus, resetReportingStateErrors, resetReportingStateValidationStatus, setReportingStateDepartureProtocolId, setReportingStateEntryProtocolId, setReportingStateNote, setReportingStateReportingOuterState } from "../slice"
import { TrashIcon } from "../../../../ui/icons/trash"
import { Alert } from "../../../../ui/organisms/alert"

export function EditRightReporting() {
    const dispatch = useAppDispatch()
    const reportingState = useAppSelector(state => state.reporting)
    const [showAlert, setShowAlert] = useState<boolean>(false)
    const [repStateToDelete, setRepStateToDelete] = useState<string | null>(null)

    useEffect(() => {
        if(reportingState.reportingStateCreationStatus === 'successfully') {
            dispatch(resetReportingStateCreationStatus())
            dispatch(resetReportingStateCreationRequest())
            dispatch(resetReportingStateErrors())
            dispatch(GetAllReportingStates({itemsPerPage: 0, page: 0, reportingId: reportingState.reportingIdToUpdate}))            
        }
    }, [reportingState.reportingStateCreationStatus])

    useEffect(() => {
        if(reportingState.reportingStateDeleteStatus === 'successfully') {
            dispatch(resetReportingStateDeleteStatus())
            dispatch(GetAllReportingStates({itemsPerPage: 0, page: 0, reportingId: reportingState.reportingIdToUpdate})) 
        }
    }, [reportingState.reportingStateDeleteStatus])

    useEffect(() => {
        if(reportingState.reportingStateValidationStatus === 'successfully') {
            dispatch(resetReportingStateValidationStatus())
            dispatch(ReportingStateCreation(reportingState.reportingStateCreationRequest))
        }
    }, [reportingState.reportingStateValidationStatus])

    useEffect(() => {
        dispatch(resetGetAllReportingStateResponse())
        dispatch(GetAllReportingStates({itemsPerPage: 0, page: 0, reportingId: reportingState.reportingIdToUpdate})) 
    }, [])

    return (
        <div className="flex flex-col gap-4 w-full">
            <div className="text-left pb-1 text-md">
                <span className="font-semibold uppercase tracking-widest text-brandPrimary-600">Stati</span>
                <span className="px-2 font-semibold uppercase tracking-widest text-brandPrimary-300">/</span>
                <span className="font-semibold uppercase tracking-widest text-brandPrimary-800">Creazione</span>
            </div>

            <div className="border-b border-neutral-200 flex flex-col gap-5 pb-4">
                <MadfarmStaticSelect
                    label="Stato"
                    placeholder={'Seleziona stato...'}
                    error={reportingState.reportingStateErrors.reportingOuterState}
                    errorLabel="Stato mancante"
                    key={reportingState.reportingStateCreationRequest.reportingOuterState || 'default'}
                    options={ReportingStateStatusOption}
                    noOptionsMessage="Nessuno stato trovato"
                    value={reportingState.reportingStateCreationRequest.reportingOuterState}
                    onChange={(value) => {
                        //@ts-ignore
                        const newValue = value !== null ? value.value : null
                        dispatch(setReportingStateReportingOuterState(newValue))
                    }}
                />

                <ProtocolSearch
                    errorLabel={reportingState.reportingStateErrors.entryProtocolId ? 'Protocollo mancante' : undefined}
                    value={reportingState.reportingStateCreationRequest.entryProtocolId}
                    type='entry'
                    defaultValue=""
                    onSelect={(value) => dispatch(setReportingStateEntryProtocolId(value))}
                />

                <ProtocolSearch
                    errorLabel={reportingState.reportingStateErrors.departureProtocolId ? 'Protocollo mancante' : undefined}
                    value={reportingState.reportingStateCreationRequest.departureProtocolId}
                    type='departure'
                    onSelect={(value) => dispatch(setReportingStateDepartureProtocolId(value))}
                />

                <TextArea
                    label="Note"
                    value={reportingState.reportingStateCreationRequest.note}
                    onChangeText={(text) => dispatch(setReportingStateNote(text))}
                />

                <div className="flex justify-end w-full">
                    <ButtonComponent
                        iconPosition="off"
                        variant="solid"
                        color="orange"
                        label="Aggiungi Stato"
                        size="sm"
                        onClick={() => dispatch(ReportingStateValidation(reportingState.reportingStateCreationRequest))}
                    />
                </div>
            </div>

            <div className="mt-4">
                {(reportingState.getAllReportingStatesResponse?.data || []).length === 0 ? (
                    <div className="px-3 py-2 rounded-lg border border-neutral-200 bg-white text-sm font-medium text-neutral-500">
                        Nessuno stato disponibile
                    </div>
                ) : (
                    reportingState.getAllReportingStatesResponse?.data.map(rs => (
                        <div key={rs.id} className="py-3">
                            <div className="state-box flex items-center justify-between gap-4">
                                <div className="flex-1">
                                    <div className="text-left">
                                        <span className="state-main">{optionsFormatter(rs.reportingOuterState, ReportingStateStatusOption)}</span>
                                    </div>
                                    <div className="text-left">
                                        <span className="state-sub">{`${rs.entryProtocolInfo} - ${rs.departureProtocolInfo}`}</span>
                                    </div>
                                    <div className="text-left">
                                        <span className="state-note">{rs.note}</span>
                                    </div>
                                </div>
                                <div className="flex items-center">
                                    <button
                                        className="p-3 border border-neutral-200 rounded-full flex justify-center items-center"
                                        onClick={() => {
                                            setRepStateToDelete(rs.id)
                                            setShowAlert(true)
                                        }}
                                    >
                                        <TrashIcon size={20} color="white" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>

            {(showAlert && repStateToDelete) && (
                <Alert title="Conferma operazione" close={() => setShowAlert(false)}>
                    <div className="flex flex-col justify-center">
                        <div className="pb-3">
                            <div>
                                Sei sicuro di voler eliminare la riga?
                            </div>
                        </div>
                        <div className="mt-6 flex items-center justify-center">
                            <ButtonComponent
                                variant="outline"
                                color="gray"
                                iconPosition="off"
                                label="Annulla"
                                size="md"
                                onClick={() => setShowAlert(false)}
                            />
                            <div className="pl-8">
                                <ButtonComponent
                                    variant="solid"
                                    color="orange"
                                    iconPosition="off"
                                    label="Elimina"
                                    size="md"
                                    onClick={() => {
                                        dispatch(ReportingStateDelete(repStateToDelete))
                                        setShowAlert(false)
                                    }}
                                />
                            </div>
                        </div>

                    </div>
                </Alert>
            )}
        </div>
    )
}